import { atom } from "jotai";
import {
	applyLocale,
	readLocale,
	type SupportedLocale,
	writeLocale,
} from "../lib/locale";

export const localeAtom = atom<SupportedLocale>(readLocale());

// locale 인자: 호출부(LocaleSync)가 라우터 상태 기준으로 이미 판정한 값을 넘길 수
// 있게 한다 — 내부에서 readLocale()을 재호출하면 window.location 레이스에 노출됨.
export const initializeLocaleAtom = atom(
	null,
	(_get, set, locale?: SupportedLocale) => {
		const resolved = locale ?? readLocale();
		applyLocale(resolved);
		set(localeAtom, resolved);
		return resolved;
	},
);

export const setLocaleAtom = atom(
	null,
	(_get, set, locale: SupportedLocale) => {
		writeLocale(locale);
		applyLocale(locale);
		set(localeAtom, locale);
	},
);
